'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ExpertTypeIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ExpertTypeIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Certified-Ribbon--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Certified Ribbon Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M4.148 14.034 0.56 20.181c-0.138 0.238 -0.028 0.395 0.243 0.349l3.358 -0.569 1.164 3.2c0.094 0.258 0.286 0.277 0.427 0.04l3.065 -5.148"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m19.852 14.034 3.588 6.147c0.138 0.238 0.028 0.395 -0.243 0.349l-3.358 -0.569 -1.164 3.2c-0.094 0.258 -0.286 0.277 -0.427 0.04l-3.065 -5.148"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M3 9.632a9 9 0 1 0 18 0 9 9 0 1 0 -18 0Z"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m15.94 7.162 -4.72 4.72a0.75 0.75 0 0 1 -1.061 0l-1.72 -1.72"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

ExpertTypeIcon.propTypes = {
  sx: PropTypes.object
}
